
import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import './registerServiceWorker.js'
import 'w3-css/w3.css'
import {auth} from './firebase.js';
import {store} from "./store.js";
import VueI18n from 'vue-i18n';

Vue.use(VueI18n)
import {languages} from './i18n/index.js'
import {defaultLocale} from './i18n/index.js'
const messages = Object.assign(languages)
var i18n = new VueI18n({
  locale:defaultLocale,
  fallbackLocale:'hu',
  messages
})

import { L } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});


import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'

import './plugins/myLocate/L.Control.Locate.css' 
import './plugins/myLocate/L.Control.Locate.js' 

import VueTimers from 'vue-timers'
Vue.use(VueTimers)

import GlobFunc from './plugins/GlobFunc';
Vue.use(GlobFunc);

import Vue2Storage from 'vue2-storage'
Vue.use(Vue2Storage, {
  prefix: 'csavargo_',
  driver: 'local',
  ttl: 60 * 60 * 24 * 1000 * 7 //7 nap
})

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faFont, faRunning, faInfo, faEuroSign, faWindowClose, faHome, faInfoCircle, faMapMarkedAlt, faMapMarkerAlt, faRoute, faAward, faBars, 
         faUser, faCog, faTimes, faDrawPolygon, faBook, faQuestionCircle, faEnvelope,
         faListUl, faAngleLeft, faFileAlt, faAngleDoubleRight, faCheckCircle, faHistory,
         faTimesCircle, faAngleDown, faAngleUp, faSpinner, faFilter, faSortAmountDown,
         faCloudDownloadAlt, faWifi, faPlusSquare, faSignOutAlt, faWalking, faStamp, 
         faExclamationTriangle, faUserCheck, faRedoAlt, faMinus, faEllipsisH, faSignInAlt,
         faFlagCheckered, faHourglassHalf, faPhone, faCloudUploadAlt, faDatabase, faSyncAlt, 
         faTrashAlt, faGlobe, faAddressCard, faEdit, faEye, faArrowCircleLeft, faArrowLeft,
         faQrcode, faQuestion, faToggleOff, faToggleOn, faLock, faUnlock, faStar,
         faClipboardList, faFilePdf, faEllipsisV, faUsers, faHiking, faFileSignature,faReceipt,
         faFileExport, faFileImport, faBicycle, faRandom, faClipboard, faTrophy, faExclamationCircle,
         faDollarSign, faPlus
          } from '@fortawesome/free-solid-svg-icons'
import { faGoogle, faFacebook } from '@fortawesome/free-brands-svg-icons'
library.add( faCheck, faFont, faRunning, faInfo, faEuroSign, faWindowClose, faHome, faInfoCircle, faMapMarkedAlt, faMapMarkerAlt, faRoute, faAward, faBars, faUser,
            faCog, faTimes, faDrawPolygon, faBook, faQuestionCircle, faEnvelope, faListUl, faAngleLeft,
            faFileAlt, faAngleDoubleRight, faCheckCircle, faHistory, faTimesCircle, faAngleDown, faAngleUp,
            faSpinner, faFilter, faSortAmountDown, faCloudDownloadAlt, faWifi, faPlusSquare, faSignOutAlt, 
            faWalking, faStamp, faExclamationTriangle, faUserCheck, faRedoAlt, faMinus, faEllipsisH, faSignInAlt,
            faFlagCheckered, faHourglassHalf, faPhone, faCloudUploadAlt, faDatabase, faSyncAlt, 
            faTrashAlt, faGlobe, faAddressCard, faEdit, faEye, faArrowCircleLeft, faArrowLeft,
            faQrcode, faQuestion, faToggleOff, faToggleOn, faLock, faUnlock, faStar,
            faClipboardList, faFilePdf, faEllipsisV, faUsers, faHiking, faFileSignature,faReceipt,
            faFileExport, faFileImport, faBicycle, faRandom, faClipboard, faTrophy, faExclamationCircle,
            faDollarSign, faPlus)
library.add(faGoogle, faFacebook)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome' 
Vue.component('font-awesome-icon', FontAwesomeIcon)

import './plugins/mySidebar/leaflet-sidebar.css'
import './plugins/mySidebar/leaflet-sidebar.js'

import VueOffline from 'vue-offline'
Vue.use(VueOffline)

import VuejsDialog from 'vuejs-dialog';
import './plugins/myVuejs-dialog/vuejs-dialog.min.css';
Vue.use(VuejsDialog,{
  html: true,
  okText: 'OK',
  reverse: true,
  cancelText: 'Mégsem',
});

const fb = require('./firebase.js')
Vue.config.productionTip = false


auth.onAuthStateChanged(function(user) {  
  let userProfile = null;
  if (user) {
    userProfile = {
      name: user.displayName,
      email: user.email,
      uid: user.uid,
      photoUrl: user.photoURL,
      provider: user.providerData[0].providerId          
    };
    if (navigator.onLine) {
      if (userProfile.name) {//e-mail-es regisztrációkor is lefut ez a kód és akkor még nincs név, ezért kell ez a feltétel        
        fb.GetUserData(user.uid).then(res=>{ 
          if (res) {
            if (res.publicName) userProfile.publicName=res.publicName; 
            if (res.name) userProfile.name=res.name; 
            if (res.gender) userProfile.gender=res.gender;
            if (res.yearOfBirth) userProfile.yearOfBirth=res.yearOfBirth;          
            if (res.address) userProfile.address=res.address;                    
            if (res.newsletter) userProfile.newsletter=res.newsletter;
          } else {//1. bejelentkezés
            fb.SetPPandNL(user.uid);
          }          
          store.commit('setUserProfile', userProfile);          
        }).catch(e=>{
          store.commit('setUserProfile', userProfile); 
        })         
        store.commit('setUserProfile', userProfile); 
      } else {
        store.commit('setUserProfile', userProfile); 
      }
    } else {//offline
      userProfile.privacypolicy=1;
      store.commit('setUserProfile', userProfile);
    }
  } else{
    store.commit('setUserProfile', userProfile);
  } 
});

window.onbeforeunload = function() {//Bezáráskor töröljük a locatin adatot
  var myStorage = window.localStorage;
  myStorage.removeItem('csavargo_location');            
};

new Vue({
  el: "#app",
  i18n,   
  store,
  router,
  render: h => h(App)
});

